import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.search";
import "core-js/modules/web.dom-collections.for-each";
import { __assign, __awaiter, __decorate, __extends, __generator } from "tslib";
import { Vue, Component, Watch } from 'vue-property-decorator';
import AddEditSkuMapping from './components/addEditSkuMapping.vue';
import { enumData, loading, userPrefPageSize } from '@/decorators';
import { OperatingStatus } from '@/enum';
import errorTipModal from '@/components/errorTipModal';
import { writePageToken, setPageToken } from '@/components/pagination';

var ProductOriginalLabelPage = function (_super) {
  __extends(ProductOriginalLabelPage, _super);

  function ProductOriginalLabelPage() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.needAddRelationEnum = [];
    _this.dataList = [];
    _this.selectedIdList = [];
    _this.operatingStatus = OperatingStatus.add;
    _this.selectedRelationBarcodeList = [];
    _this.fieldEnum = [{
      text: _this.t('商品编码'),
      value: 'product_sku'
    }, {
      text: _this.t('参考编码'),
      value: 'reference_number'
    }, {
      text: _this.t('中文名称'),
      value: 'product_name_cn'
    }, {
      text: _this.t('原标商品编码'),
      value: 'relation_barcode'
    }];
    _this.searchData = _this.initSearchdata();
    _this.cacheSearchData = _this.initSearchdata();
    _this.total = 0;
    _this.loadingStatus = false;
    _this.listLoading = false;
    _this.platformList = [];
    _this.platformAccountList = [];
    _this.rowSelection = {};
    _this.editData = {};
    _this.searchDateTime = _this.$util.getDefaultTimeCondition();
    _this.columns = [{
      title: _this.t('商品编码'),
      dataIndex: 'product_sku',
      isCopy: true
    }, {
      title: _this.t('参考编码'),
      dataIndex: 'reference_number',
      filterEmpty: true,
      isCopy: true
    }, {
      title: _this.t('中文名称'),
      dataIndex: 'product_name_cn',
      scopedSlots: {
        customRender: 'product_name_cn'
      }
    }, {
      title: _this.t('来源仓'),
      dataIndex: 'third_part_platform',
      filterEmpty: true
    }, {
      title: _this.t('原标商品编码'),
      dataIndex: 'relation_barcode',
      filterEmpty: true,
      isCopy: true
    }, {
      title: _this.t('更新时间'),
      dataIndex: 'update_time',
      filterEmpty: true
    }, {
      title: _this.t('操作'),
      width: 150,
      scopedSlots: {
        customRender: 'operation'
      }
    }];
    return _this;
  }

  ProductOriginalLabelPage.prototype.initSearchdata = function () {
    return {
      code_field: 'product_sku',
      code_value: '',
      third_part_platform: '',
      update_time_from: '',
      update_time_to: '',
      page_index: 1,
      page_size: 20
    };
  };

  ProductOriginalLabelPage.prototype.onSearchDateTime = function (arr) {
    if (arr.length) {
      this.searchData.update_time_from = this.$util.formatDateTime(arr[0]);
      this.searchData.update_time_to = this.$util.formatDateTime(arr[1]);
    } else {
      this.searchData.update_time_from = '';
      this.searchData.update_time_to = '';
    }
  };

  ProductOriginalLabelPage.prototype.search = function () {
    return __awaiter(this, void 0, Promise, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            this.rowSelection.selectedRowKeys = this.selectedIdList = [];
            return [4, this.queryOriginalLabelList(this.searchData)];

          case 1:
            _a.sent();

            return [2];
        }
      });
    });
  };

  ProductOriginalLabelPage.prototype.queryOriginalLabelList = function (params) {
    return __awaiter(this, void 0, Promise, function () {
      var _a, code, data;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            this.cacheSearchData = params;
            return [4, this.$api.product.queryOriginalLabelList(params)];

          case 1:
            _a = _b.sent(), code = _a.code, data = _a.data;

            if (code === 0) {
              this.dataList = data.data;
              this.total = data.total;
              writePageToken(this.searchData, {
                prev_token: data.prev_token,
                next_token: data.next_token,
                zt_list_es_point: data.zt_product_list_es_point
              });
            }

            return [2];
        }
      });
    });
  };

  ProductOriginalLabelPage.prototype.removeOriginalLabel = function (params) {
    return __awaiter(this, void 0, Promise, function () {
      var res, data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.$api.product.removeOriginalLabel(params)];

          case 1:
            res = _a.sent();

            if (res.code === 0) {
              data = res.data || [];
              data.forEach(function (item) {
                item.error_list.forEach(function (error) {
                  error.keyword = item.keyword;
                });
              });
              data.length && errorTipModal(data);
              this.search();
            }

            return [2];
        }
      });
    });
  };

  ProductOriginalLabelPage.prototype["export"] = function (params) {
    return __awaiter(this, void 0, Promise, function () {
      var res;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.$api.product.exportOriginalLabel(params)];

          case 1:
            res = _a.sent();

            if (res.code === 0) {
              this.$util.exportExcel(res.data);
            }

            return [2];
        }
      });
    });
  };

  ProductOriginalLabelPage.prototype.handleReset = function () {
    var _this = this;

    this.searchData = this.initSearchdata();
    this.searchDateTime = this.$util.getDefaultTimeCondition();
    this.$nextTick(function () {
      return _this.search();
    });
  };

  ProductOriginalLabelPage.prototype.handlePageChange = function (pageIndex, pageSize) {
    setPageToken(this.searchData, pageIndex);
    this.searchData.page_index = pageIndex;
    this.searchData.page_size = pageSize;
    this.search();
  };

  ProductOriginalLabelPage.prototype.handleExportSelected = function () {
    if (!this.selectedIdList.length) {
      this.$message.warning(this.tc(this.$config.exportSelectedEmptyTip));
      return;
    }

    this["export"]({
      product_id_list: this.selectedIdList
    });
  };

  ProductOriginalLabelPage.prototype.handleExportAll = function () {
    this["export"](this.cacheSearchData);
  };

  ProductOriginalLabelPage.prototype.handleRemoveSkuMapping = function (row) {
    var _this = this;

    this.$confirm({
      title: this.tc('温馨提示'),
      content: this.t('请确认是否删除该项？'),
      onOk: function onOk() {
        _this.removeOriginalLabel({
          relation_barcode_list: [row.relation_barcode],
          product_status: _this.$enum.product.ProductStatusEnum.AVAILABLE
        });
      }
    });
  };

  ProductOriginalLabelPage.prototype.handleRemoveSelectedSkuMapping = function () {
    var _this = this;

    if (!this.selectedRelationBarcodeList.length) {
      this.$message.warning(this.t('请选择删除项'));
      return;
    }

    this.$confirm({
      title: this.tc('温馨提示'),
      content: this.t('请确认是否删除已选项？'),
      onOk: function onOk() {
        _this.removeOriginalLabel({
          relation_barcode_list: _this.selectedRelationBarcodeList,
          product_status: _this.$enum.product.ProductStatusEnum.AVAILABLE
        });
      }
    });
  };

  ProductOriginalLabelPage.prototype.handleAddMapping = function () {
    this.operatingStatus = OperatingStatus.add;
    var addEditSkuMappingRef = this.$refs.addEditSkuMappingRef;
    addEditSkuMappingRef.visible = true;
  };

  ProductOriginalLabelPage.prototype.handleEditMapping = function (row) {
    this.operatingStatus = OperatingStatus.edit;
    var addEditSkuMappingRef = this.$refs.addEditSkuMappingRef;
    this.editData = __assign({}, row);
    addEditSkuMappingRef.visible = true;
  };

  ProductOriginalLabelPage.prototype.handleSuccess = function () {
    this.search();
  };

  ProductOriginalLabelPage.prototype.handleSearch = function () {
    return __awaiter(this, void 0, Promise, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            this.searchData.page_index = 1;
            return [4, this.search()];

          case 1:
            _a.sent();

            return [2];
        }
      });
    });
  };

  ProductOriginalLabelPage.prototype.created = function () {
    var _this = this;

    this.rowSelection = {
      selectedRowKeys: [],
      onChange: function onChange(selectedRowKeys, selectedRows) {
        _this.rowSelection.selectedRowKeys = _this.selectedIdList = selectedRowKeys;
        _this.selectedRelationBarcodeList = selectedRows.map(function (item) {
          return item.relation_barcode;
        });
      }
    };
    this.search();
  };

  __decorate([enumData('ProductSkuMapping/NeedAddRelationEnum')], ProductOriginalLabelPage.prototype, "needAddRelationEnum", void 0);

  __decorate([userPrefPageSize('originalLabelProductList')], ProductOriginalLabelPage.prototype, "initSearchdata", null);

  __decorate([Watch('searchDateTime', {
    immediate: true
  })], ProductOriginalLabelPage.prototype, "onSearchDateTime", null);

  __decorate([loading('listLoading')], ProductOriginalLabelPage.prototype, "queryOriginalLabelList", null);

  __decorate([loading('loadingStatus')], ProductOriginalLabelPage.prototype, "handleSearch", null);

  ProductOriginalLabelPage = __decorate([Component({
    components: {
      AddEditSkuMapping: AddEditSkuMapping
    }
  })], ProductOriginalLabelPage);
  return ProductOriginalLabelPage;
}(Vue);

export default ProductOriginalLabelPage;